export const updateFiles = (payload?: any) => ({
    type: "@saga/UPDATE_DOCUMENT_FILES",
    payload
});

